import { GameType, RoomSource } from "../domain/models/types";
import {
  GlobalLeaderboardRequestDTO,
  GlobalLeaderBoardResponseDTO,
} from "./dto/GlobalLeaderboardDTO";
import { NetworkService } from "./NetworkService";

interface ILeaderboardService {
  getLeaderboard(
    gameType: GameType,
    roomSource: RoomSource
  ): Promise<GlobalLeaderBoardResponseDTO>;
}

class LeaderboardService implements ILeaderboardService {
  private convertGameTypeToAPI(type: GameType): number {
    switch (type) {
      case "Basic":
        return 1;
      case "Advanced":
        return 2;
      case "Expert":
        return 3;
      case "Genius":
        return 4;
    }
  }

  getLeaderboard(
    gameType: GameType,
    roomSource: RoomSource
  ): Promise<GlobalLeaderBoardResponseDTO> {
    switch (roomSource) {
      case "Teacher":
        return this.getTeacherLeaderboard(this.convertGameTypeToAPI(gameType));
      case "ClassRoom":
        return this.getGlobalLeaderboard(this.convertGameTypeToAPI(gameType));
    }
  }

  private getTeacherLeaderboard(
    gameTypeNumber: number
  ): Promise<GlobalLeaderBoardResponseDTO> {
    return NetworkService.shared.post<
      GlobalLeaderboardRequestDTO,
      GlobalLeaderBoardResponseDTO
    >("/leaderboard/teacher", { gameType: gameTypeNumber });
  }

  private getGlobalLeaderboard(
    gameTypeNumber: number
  ): Promise<GlobalLeaderBoardResponseDTO> {
    return NetworkService.shared.post<
      GlobalLeaderboardRequestDTO,
      GlobalLeaderBoardResponseDTO
    >("/leaderboard/global", { gameType: gameTypeNumber });
  }
}

export const leaderboardService: ILeaderboardService = new LeaderboardService();
